<template>
  <div v-if="options">
    <v-dialog scrollable max-width="1200" v-model="model" persistent>
      <material-card
        :title="
          $t('components.guides.import_guide_dialog.import_guide_{0}', [
            guideTitle(),
          ])
        "
        :color="$vuetify.theme.themes.light.success"
        icon="add"
        v-if="item !== null && item !== undefined"
      >
        <v-card-text>
          <v-form v-model="valid">
            <v-container>
              <v-row justify-center>
                <v-col cols="12" sm="6" md="4">
                  <auto-select2
                    :clearable="true"
                    :value="item.Province"
                    @change="provinceChanged"
                    :items="provincesList"
                    :label="$t('globals.province')"
                    @add="provinceDialog = true"
                    :showAddBtn="true"
                    class="required"
                    :rules="[$rules.required]"
                    hide-no-data
                    item-value="Id"
                    :item-text="trans"
                    return-object
                  ></auto-select2>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-show="item.Province">
                  <auto-select2
                    :clearable="true"
                    :value="item.Year"
                    @change="yearChanged"
                    :items="years"
                    :label="$t('headers.t4a_archive.year')"
                    @add="yearDialog = true"
                    :showAddBtn="true"
                    class="required"
                    :rules="[$rules.required]"
                    @keyup="onSearchYear"
                    :search-input="searchYear"
                    hide-no-data
                    item-value="Year"
                    item-text="Year"
                    return-object
                  ></auto-select2>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-show="item.Year">
                  <auto-select2
                    :clearable="true"
                    :value="item.GeoLocation"
                    @change="geoChanged"
                    :items="geolocations"
                    :label="
                      $t('components.guides.import_guide_dialog.geolocation')
                    "
                    @add="geoDialog = true"
                    :showAddBtn="true"
                    class="required"
                    :rules="[$rules.required]"
                    hide-no-data
                    item-value="GeoLocation"
                    :item-text="(item) => translateEnum(item)"
                    return-object
                  ></auto-select2>
                </v-col>
                <v-col xs="12" sm="6" md="4" v-if="item.GeoLocation">
                  <auto-select2
                    :clearable="true"
                    :value="item.Guide"
                    @change="guideChanged"
                    :items="guides"
                    :label="
                      $t('components.guides.health_reasonable_customary.guides')
                    "
                    @add="guideDialog = true"
                    :showAddBtn="true"
                    class="required"
                    :rules="[$rules.required]"
                    @keyup="onSearchGuide"
                    :search-input="searchGuide"
                    hide-no-data
                  ></auto-select2>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-show="showFileInput">
                  <v-file-input
                    show-size
                    accept=".xlsx"
                    :label="
                      $t('components.guides.import_guide_dialog.service_fees')
                    "
                    ref="file"
                    v-on:change="handleFileChange"
                    :rules="[$rules.required]"
                    class="required"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-alert
            v-for="(error, i) in errors"
            dense
            type="error"
            :key="i"
            dismissible
          >
            {{ $t(error) }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              $emit('close');
              item = null;
            "
            :loading="saving"
          >
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="primary"
            @click="save"
            :disabled="!valid || errors.length > 0"
            :loading="saving"
          >
            {{ $t("globals.import") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      persistent
      v-model="yearDialog"
      max-width="fit-content"
    >
      <material-card
        :title="$t('components.guides.add_year')"
        icon="add"
        :color="$vuetify.theme.themes.light.success"
      >
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-form v-model="validYear">
              <v-row>
                <div class="col-12 col-xs-12 col-sm-6">
                  <no-autocomplete-textfield
                    v-model="year"
                    :label="$t('headers.t4a.Year')"
                    :rules="[$rules.required]"
                    class="required"
                  ></no-autocomplete-textfield>
                </div>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              yearDialog = false;
              year = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn :disabled="!validYear" color="primary" @click="saveYear">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      persistent
      v-model="guideDialog"
      max-width="fit-content"
    >
      <material-card
        :title="$t('components.guides.add_guide')"
        icon="add"
        :color="$vuetify.theme.themes.light.success"
      >
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-form v-model="validGuide">
              <v-row>
                <div class="col-12 col-xs-12 col-sm-6">
                  <no-autocomplete-textfield
                    v-model="guide"
                    :label="
                      $t('components.guides.health_reasonable_customary.guides')
                    "
                    :rules="[$rules.required]"
                    class="required"
                  ></no-autocomplete-textfield>
                </div>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              guideDialog = false;
              guide = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn :disabled="!validGuide" color="primary" @click="saveGuide">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      persistent
      v-model="provinceDialog"
      max-width="fit-content"
    >
      <material-card
        :title="$t('components.guides.add_province')"
        icon="add"
        :color="$vuetify.theme.themes.light.success"
      >
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-form v-model="validProvince">
              <v-row>
                <div class="col-12 col-xs-12 col-sm-6">
                  <trans-select
                    :clearable="true"
                    :item="province"
                    propertyName="Province"
                    :items="options.Models.Province.filter((o) => provinces.filter((oo) => oo.ProvinceId === o.Id).length === 0)"
                    :label="$t('globals.province')"
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-select>
                </div>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              provinceDialog = false;
              province = {};
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn :disabled="!validProvince" color="primary" @click="saveProvince">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      scrollable
      persistent
      v-model="geoDialog"
      max-width="fit-content"
    >
      <material-card
        :title="$t('components.guides.add_geo')"
        icon="add"
        :color="$vuetify.theme.themes.light.success"
      >
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-form v-model="validGeo">
              <v-row>
                <div class="col-12 col-xs-12 col-sm-6">
                  <v-select
                    v-model="geo"
                    :label="
                      $t('components.guides.import_guide_dialog.geolocation')
                    "
                    :rules="[$rules.required]"
                    class="required"
                    :items="options.Enums.GeoLocation"
                    :item-text="(item) => translateEnum(item)"
                  ></v-select>
                </div>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              geoDialog = false;
              geo = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn :disabled="!validGeo" color="primary" @click="saveGeo">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import ErrorHandler from "../../components/ErrorHandler.vue";
import { mapActions, mapGetters } from "vuex";
import AutoSelect2 from "../AutoSelect2.vue";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";
import { translate } from "@/trans";
import TransSelect from "../TransSelect.vue";

export default {
  props: ["model", "coverage"],
  components: {
    ErrorHandler,
    AutoSelect2,
    NoAutocompleteTextfield,
    TransSelect
  },
  data() {
    return {
      showFileInput: false,
      error: null,
      item: null,
      successDialog: false,
      valid: false,
      saving: false,
      file: null,
      errors: [],
      guides: [],
      years: [],
      provincesList: null,
      geolocations: [],
      provinces: [],
      searchYear: null,
      yearDialog: false,
      validYear: false,
      year: null,
      searchGuide: null,
      guideDialog: false,
      validGuide: false,
      guide: null,
      validProvince:false,
      province: {},
      provinceDialog: false,
      geoDialog: false,
      validGeo: false,
      geo: null,
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language"]),
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.item = {
            Coverage: this.coverage,
          };
          this.errors = [];
        }
      },
    },
  },
  mounted() {
    this.item = {
      Coverage: this.coverage,
    };
    this.loadProvinces();
  },
  methods: {
    ...mapActions("claims", ["importFeeGuide", "getFeeGuides", "getFees"]),
    provinceChanged(v) {
      this.item.Province = v;
      if (v) {
        
          console.log("province is", v);
          let province = this.provinces.filter((o) => o.ProvinceId === v.Id)[0];
          console.log("province is", province);
          this.years = province.Years;
          this.geolocations = [];
          this.guides = [];
          this.item.Year = null;
          this.item.Guide = null;
          this.item.GeoLocation = null;
          this.showFileInput = false;
          if (this.years.length === 1) {
            this.item.Year = this.years[0];
          }
        }
    },
    yearChanged(v) {
      this.item.Year = v;
      if (v) {
        
          console.log("year is: ", v);
          this.geolocations = v.GeoLocations;
          this.guides = [];
          if (this.geolocations.length === 1) {
            this.item.GeoLocation = this.geolocations[0];
          }
        }
    },
    geoChanged(v) {
      this.item.GeoLocation = v;
      if (v) {
          console.log("geo is: ", v);
          this.guides = v.Names;
          if (this.guides.length === 1) {
            this.item.Guide = this.guides[0];
            this.showFileInput = true;
          }
        }
    },
    guideChanged(v) {
      console.log("Guide Changed", v)
      this.$nextTick(()=>{
        console.log("Guide Changed: next tick: ", v)
        this.item.Guide = v;
        this.showFileInput = v !== null && v!==undefined && v!=="";
      });
    },
    translateEnum(item) {
      return this.$t(`enums.${item.GeoLocation}`);
    },
    trans(item) {
      // console.log("!@!@!@!@!@!@!@!@!@!@!@!@!@!@!@!@!@!2", item, this.language.language);
      let a=translate(item, this.language.language);
      // console.log(a);
      return a;
    },
    guideTitle() {
      if (this.coverage === "Health") {
        return this.$t("views.guides.health_reasonable_&_customary_guides_2");
      }
      return this.$t("views.guides.dental_fee_guides");
    },
    async loadProvinces() {
      this.provinces = (
        await this.getFeeGuides({
          coverage: this.coverage,
        })
      ).data;
      this.provincesList = this.options.Models.Province.filter(
        (o) => this.provinces.filter((oo) => oo.ProvinceId === o.Id).length > 0
      );
    },
    handleFileChange(file) {
      if (!file) {
        this.file = null;
        this.errors = [];
        return;
      }
      if (file.length == 0) {
        this.errors = [];
        return;
      }
      this.file = file;
    },
    async save() {
      try {
        this.saving = true;
        console.log(this.item);
        let item = JSON.parse(JSON.stringify(this.item));
        if (item.Province) {
          item.ProvinceId = item.Province.Id;
          delete item.Province;
        }
        item.Year = item.Year.Year;
        item.GeoLocation = item.GeoLocation.GeoLocation;
        await this.importFeeGuide({
          payload: item,
          file: this.file,
        });
        this.$emit("success", this.$t("globals.success"));
      } catch (error) {
        this.errors = [];
        if (
          error.response &&
          error.response.status === 409 &&
          error.response.data.Code === 2700
        ) {
          const errors = JSON.parse(error.response.data.Message);
          console.log(errors);
          if (errors["2700"] !== null && errors["2700"] !== undefined) {
            if (errors["2700"].valid === false) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2700")
              );
            }
          }
          if (errors["2701"] !== null && errors["2701"] !== undefined) {
            for (const row of errors["2701"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2701_{0}_{1}", [
                  row.wrong_name,
                  row.correct_name,
                ])
              );
            }
          }
          if (errors["2702"] !== null && errors["2702"] !== undefined) {
            for (const row of errors["2702"].rows) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2702_{0}", [
                  row.toString(),
                ])
              );
            }
          }
          if (errors["2703"] !== null && errors["2703"] !== undefined) {
            for (const row of errors["2703"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2703_{0}_{1}", [
                  row.row,
                  row.column,
                ])
              );
            }
          }
          if (errors["2704"] !== null && errors["2704"] !== undefined) {
            for (const row of errors["2704"].rows) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2704_{0}", [
                  row.toString(),
                ])
              );
            }
          }
          if (errors["2705"] !== null && errors["2705"] !== undefined) {
            for (const row of errors["2705"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2705_{0}_{1}_{2}", [
                  row.row,
                  row.column,
                  row.type,
                ])
              );
            }
          }
          if (errors["2706"] !== null && errors["2706"] !== undefined) {
            for (const row of errors["2706"]) {
              this.errors.push(
                this.$t("components.errorhandler.error409_2706_{0}", [
                  row.column,
                ])
              );
            }
          }
        } else {
          this.error = error;
        }
      } finally {
        this.saving = false;
      }
    },
    async onSearchYear(evt) {
      // console.log(evt.keyCode, evt.target.value);
      if (evt.keyCode >= 37 && evt.keyCode <= 40) {
        return;
      }
      if (evt.keyCode === 13) {
        return;
      }
      const obj = {};
      this.searchMonitor = obj;
      await this.delay(800);
      if (this.searchMonitor !== obj) {
        return;
      }
      this.filterYears(evt.target.value);
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async filterYears(search) {
      if (search === null || search === undefined || search === "") {
        return;
      }
      let province = this.provinces.filter(
        (o) => o.ProvinceId === this.item.Province.Id
      )[0];
      this.years = province.Years.filter((o) => o.indexOf(search) > -1);
    },
    saveYear() {
      let province = this.provinces.filter(
        (o) => o.ProvinceId === this.item.Province.Id
      )[0];
      console.log(province, this.year);
      province.Years.unshift({
        Year: this.year,
        GeoLocations:[]
      });
      this.years.unshift({
        Year: this.year,
        GeoLocations:[]
      });
      this.item.Year = {
        Year: this.year,
        GeoLocations:[]
      };
      this.yearDialog = false;
      this.year = null;
    },
    async onSearchGuide(evt) {
      // console.log(evt.keyCode, evt.target.value);
      if (evt.keyCode >= 37 && evt.keyCode <= 40) {
        return;
      }
      if (evt.keyCode === 13) {
        return;
      }
      const obj = {};
      this.searchMonitor = obj;
      await this.delay(800);
      if (this.searchMonitor !== obj) {
        return;
      }
      this.filterGuides(evt.target.value);
    },
    async filterGuides(search) {
      if (search === null || search === undefined || search === "") {
        return;
      }
      this.guides = this.item.GeoLocation.Names.filter(
        (o) => o.indexOf(search) > -1
      );
    },
    saveGuide() {
      this.item.GeoLocation.Names.unshift(this.guide);
      this.guides.unshift(this.guide);
      this.item.Guide = this.guide;
      this.showFileInput = true;
      this.guideDialog = false;
      this.guide = null;
    },
    saveProvince() {
      this.provincesList.unshift(this.province.Province);
      this.provinces.unshift({
        ProvinceId:this.province.Province.Id,
        Years:[]
      })
      this.item.Province = this.province.Province;
      this.provinceDialog = false;
      this.province = {};
    },
    saveGeo() {
      this.item.Year.GeoLocations.unshift({
        GeoLocation: this.geo,
        Names:[]
      });
      this.geolocations.unshift({
        GeoLocation: this.geo,
        Names:[]
      });
      this.item.GeoLocation = {
        GeoLocation: this.geo,
        Names:[]
      };
      this.geoDialog = false;
      this.geo = null;
    },
  },
};
</script>

<style></style>
